var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import Badge from './Badge';
import THEME from '../theme';
import { Plus, X } from './Icons';
import Modal from './Modal';
import Button from './Button';
import Table from './Table';
import SearchInput from './SearchInput';
const TagsEditor = (props) => {
    const [open, setOpen] = useState(false);
    return (React.createElement(React.Fragment, null,
        props.tags.map((tag, index) => (React.createElement(Badge, { style: {
                fontSize: '0.6em',
                marginLeft: index !== 0 ? '10px' : undefined,
                cursor: 'pointer',
            }, onClick: () => setOpen(!open), theme: THEME.COLOR_ACCENT, title: tag.from || tag.to
                ? `(${tag.from
                    ? moment(tag.from).format(THEME.DATE_FORMAT_LONG)
                    : '∞'} - ${tag.to ? moment(tag.to).format(THEME.DATE_FORMAT_LONG) : '∞'})`
                : '' },
            (props.translations && props.translations[tag.tag]) || tag.tag,
            ' ',
            tag.from || tag.to
                ? `(${tag.from
                    ? moment(tag.from).format(THEME.DATE_FORMAT_SHORT)
                    : '∞'} - ${tag.to ? moment(tag.to).format(THEME.DATE_FORMAT_SHORT) : '∞'})`
                : ''))),
        props.tags.length === 0 && (React.createElement(Badge, { style: { cursor: 'pointer', fontSize: '0.6em' }, theme: THEME.COLOR_GREY, onClick: () => setOpen(!open) },
            React.createElement(Plus, { style: { margin: '0.2em 0 -0.2em 0' } }),
            " Tags")),
        open && React.createElement(TagsModal, Object.assign({}, props, { setOpen: setOpen }))));
};
export default TagsEditor;
const TagsModal = (props) => {
    const lang = useSelector((state) => state.lang);
    const [saving, setSaving] = useState(false);
    const [tags, setTags] = useState(props.tags);
    const [availableTags, setAvailableTags] = useState(props.availableTags || []);
    const loadTags = () => __awaiter(void 0, void 0, void 0, function* () {
        if (props.loadUsedTags) {
            setAvailableTags(availableTags.concat(yield props.loadUsedTags()));
        }
    });
    useEffect(() => {
        loadTags();
    }, []);
    return (React.createElement(Modal, { header: "Tags", onToggle: () => props.setOpen(false), maxWidth: "400px" },
        React.createElement(Table, { zebra: true }, tags.map((tag, index) => (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement(Badge, { style: {
                        fontSize: '0.6em',
                    }, theme: THEME.COLOR_ACCENT, title: tag.from || tag.to
                        ? `(${tag.from
                            ? moment(tag.from).format(THEME.DATE_FORMAT_LONG)
                            : '∞'} - ${tag.to
                            ? moment(tag.to).format(THEME.DATE_FORMAT_LONG)
                            : '∞'})`
                        : '' },
                    (props.translations && props.translations[tag.tag]) || tag.tag,
                    ' ',
                    tag.from || tag.to
                        ? `(${tag.from
                            ? moment(tag.from).format(THEME.DATE_FORMAT_SHORT)
                            : '∞'} - ${tag.to
                            ? moment(tag.to).format(THEME.DATE_FORMAT_SHORT)
                            : '∞'})`
                        : '')),
            React.createElement("td", null,
                React.createElement(X, { style: { cursor: 'pointer', float: 'right' }, onClick: () => setTags(tags.filter((_, i) => i !== index)) })))))),
        React.createElement("br", null),
        React.createElement(SearchInput, { placeholder: "+ tag", forceOpen: true, autofocus: true, searchAll: (q) => {
                let res = [];
                if (availableTags.length) {
                    res = res.concat(availableTags
                        .filter((t) => {
                        if (!q) {
                            return true;
                        }
                        return ((props.translations && props.translations[t]) || t)
                            .toLowerCase()
                            .includes(q.toLowerCase());
                    })
                        .map((t) => ({
                        heading: (props.translations && props.translations[t]) || t,
                        returnData: t,
                        key: t,
                    })));
                }
                if (q && !res.find((r) => r.returnData === q)) {
                    res = res.concat({
                        heading: q,
                        returnData: q,
                        key: q,
                    });
                }
                return res;
            }, onSelect: (t) => {
                setTags(tags.concat({
                    tag: t,
                    from: null,
                    to: null,
                }));
            } }),
        React.createElement(Button, { block: true, loading: saving, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                setSaving(true);
                try {
                    yield props.onChange(tags);
                    props.setOpen(false);
                }
                catch (error) {
                    alert('Could not save tags');
                    console.error(error);
                }
                setSaving(false);
            }) },
            lang.inputs.save,
            ' ')));
};
//# sourceMappingURL=TagsEditor.js.map